import React, {FC, useEffect, useState} from "react";
import {Clp, ClpData} from "../../../../../models/Clp";
import TypeIssuesWidget from "./TypeIssuesWidget";
import EstimatesWidget from "./EstimatesWidget";
import DetailedDataWidget from "./DetailedDataWidget";
import {capitalize, Grid, styled} from "@mui/material";
import {Skeleton as MuiSkeleton} from "@material-ui/lab";

const PRICES: { [key: number]: number } = {
    1: 20,
    2: 50,
    3: 500,
    4: 5000,
    5: 50000
}

const Skeleton = styled(MuiSkeleton)`
  background-color: #232F3E
`

type PropsType = {
    data: ClpData[]
    isLoading: boolean
}

const ChecklistCostsTab: FC<PropsType> = ({data, isLoading}) => {
    const [checklist, setChecklist] = useState<any>(null)

    useEffect(() => {
        if (data.length > 0) {
            let preparedData: Clp[] = []
            data.forEach((i) => {
                preparedData = [
                    ...preparedData,
                    ...i.clps.map((clp) => ({
                        ...clp,
                        unit_title: i.title,
                        unit_name: i.name,
                        name: `${capitalize(clp.attribute.split("_").join(" "))}`,
                        price: clp.price_level && PRICES[clp.price_level] ? PRICES[clp.price_level] : 0
                    }))]
            })
            const filteredData = preparedData.filter((i) => i.price !== 0 && !i.is_done)
            setChecklist(filteredData)
        } else {
            setChecklist([])
        }
    }, [data]);

    return (
        <Grid container spacing={2}>
            <Grid item sm={12} md={8} lg={9} order={{xs: 2, sm: 2, md: 1 }}>
                {isLoading ? (<Skeleton variant='rect' height={357} style={{borderRadius: 6}}/>) : (
                    <TypeIssuesWidget data={checklist} />
                )}
            </Grid>
            <Grid item sm={12} md={4} lg={3} order={{xs: 1, sm: 1, md: 2}}>
                {isLoading ? (<Skeleton variant='rect' height={357} style={{borderRadius: 6}}/>) : (
                    <EstimatesWidget data={checklist} />
                )}
            </Grid>
            <Grid item xs={12} order={{xs: 1, sm: 1, md: 2}}>
                {isLoading ? (<Skeleton variant='rect' height={357} style={{borderRadius: 6}}/>) : (
                    <DetailedDataWidget data={checklist} />
                )}
            </Grid>
        </Grid>
    )
}

export default ChecklistCostsTab